export default __webpack_public_path__ + "static/1036-ac0917815bf9e362bde548ab0b7891ef.gif";